import {BigWinModuleV2} from '@gongxigames/framework/slotV2/modules/bigwin/BigWinModuleV2';
import {bigWinStore} from '@gongxigames/framework/slotV2/modules/bigwin/bigWinStore';
import {KoalaBigWinView} from '@gongxigames/framework/slotV2/modules-koala/bigwin/KoalaBigWinView';
import {GameOnlyEventMap} from '@gongxigames/framework/slotV2/globals';

export class KoalaBigWinModule extends BigWinModuleV2<GameOnlyEventMap> {
    protected onInit(): void {
        bigWinStore.batchUpdate({
            big_win_thresholds: {
                big_win_play: 20,
                big_mega_win_play: 50,
                big_mega_ultra_win_play: 100
            },
            big_win_threshold: 20
        });

        this.view = new KoalaBigWinView({
            onBigWinFinished: this.onBigWinFinished.bind(this),
            onMeterStarted: this.onMeterStarted.bind(this),
            onMeterFinalValue: this.onMeterFinalValue.bind(this),
            onMeterFinished: this.onMeterFinished.bind(this)
        });
        this.container.addChild(this.view.container);
    }
}
